import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import useEventThunk from "../../Hooks/thunk/event";
import { EventById } from "../../utils/ApiConstant";
import { getEventImageUrl, dateFormatter } from "../../utils/Helper";
import Input from "../UiElement/FormElement/Input";
import SubmitButtonGroup from "../UiElement/FormElement/SubmitBtnGroup";
import { PublishEventApi } from "../../utils/ApiConstant";
import useHttpHook from "../../Hooks/HttpHook";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import { toast } from "react-toastify";
import moment from "moment";
import { showErrorToast } from "../../utils/notify";

const Publish = () => {
  const eventData = useSelector((state) => state.event.data);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, sendRequest, error] = useHttpHook();
  const eventstatus = useSelector((state) => state.event.status);
  const [ShowPublish, setShowPublish] = useState(false);
  const dispatch = useDispatch();
  const { eventId } = useParams();
  const navigate = useNavigate();
  const updEventDataWithFetch = useEventThunk();

  useEffect(() => {
    if (!eventstatus) {
      dispatch(updEventDataWithFetch(EventById + eventId));
    } else {
      reset({
        publishType: eventData.settings.publishType,
        publishTime: moment(eventData.settings.publishTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      });
    }
  }, [eventstatus]);

  useEffect(() => {
    if (eventData?.settings?.publishType === "scheduled") {
      setShowPublish(true);
    }
  }, [eventData]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const onSubmit = async (data) => {
    const event = await sendRequest(PublishEventApi + eventId, {
      method: "post",
      data,
    });

    if (event.status === 1) {
      navigate(`/organizer/MyEvents`, { replace: true });
    }
  };

  const ticketCount =
    eventData?.ticketType?.reduce(
      (result, ticketType) => result + ticketType.quantity,
      0
    ) || 0;

  const previewTags = (eventData?.tag || []).filter(
    (tag) => typeof tag === "string" && tag.trim()
  );

  const previewImage =
    eventData?.mainimage?.[0]?.path &&
    getEventImageUrl(eventData.mainimage[0].path);

  return (
    <>
      {eventstatus && (
        <MainComponentWrapper Loading={loading}>
          <div className="evntFormUI event-publish-form-wrap">
            <article className="event-publish-preview" aria-label="Event preview">
              <div className="event-publish-preview-media">
                {previewImage ? (
                  <img
                    className="event-publish-preview-image"
                    src={previewImage}
                    alt={eventData.title || "Event preview"}
                  />
                ) : (
                  <div
                    className="event-publish-preview-image event-publish-preview-placeholder"
                    aria-hidden="true"
                  >
                    <i className="bi bi-image"></i>
                  </div>
                )}
              </div>
              <div className="event-publish-preview-content">
                <p className="event-publish-preview-date">
                  {dateFormatter(eventData.eventTiming.startDate)}
                </p>
                <h2 className="event-publish-preview-title">
                  {eventData.title}
                </h2>
                <p className="event-publish-preview-desc">
                  {eventData.description}
                </p>
                <p className="event-publish-preview-meta">
                  <span className="event-publish-preview-label">
                    Number of Tickets:
                  </span>{" "}
                  {ticketCount}
                </p>
                <p className="event-publish-preview-meta">
                  <span className="event-publish-preview-label">Category:</span>{" "}
                  {eventData.category}
                </p>
                {previewTags.length > 0 && (
                  <div className="event-publish-preview-tags-wrap">
                    <span className="event-publish-preview-label">Tags:</span>
                    <div className="event-publish-tags" aria-label="Event tags">
                      {previewTags.map((tag, index) => (
                        <span className="event-publish-tag" key={index}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </article>

            <section
              className="event-publish-privacy"
              aria-labelledby="eventPublishPrivacyTitle"
            >
              <h2
                className="event-publish-section-title"
                id="eventPublishPrivacyTitle"
              >
                Privacy Settings
              </h2>
              <form onSubmit={handleSubmit(onSubmit)} id="publishForm">
                <div
                  className="event-publish-radio-row"
                  role="radiogroup"
                  aria-label="Publish mode"
                >
                  <Input
                    Id="publish-now"
                    LabelCls="event-settings-radio-label"
                    LabelPosition="bottom"
                    defValue="publish"
                    element="radio"
                    WrapperClass="event-settings-radio"
                    CustomFormGroupCls="event-settings-radio-group"
                    InputClassName="event-settings-radio-input"
                    Register={register}
                    Errors={errors}
                    FieldName="publishType"
                    Label="Publish Now"
                    clickHandler={() => {
                      setShowPublish(false);
                    }}
                    ValidationArr={[{ Type: "required" }]}
                  />
                  <Input
                    Id="publish-scheduled"
                    LabelCls="event-settings-radio-label"
                    LabelPosition="bottom"
                    defValue="scheduled"
                    element="radio"
                    WrapperClass="event-settings-radio"
                    CustomFormGroupCls="event-settings-radio-group"
                    InputClassName="event-settings-radio-input"
                    Register={register}
                    Errors={errors}
                    FieldName="publishType"
                    Label="Scheduled Publish"
                    clickHandler={() => {
                      setShowPublish(true);
                    }}
                    ValidationArr={[{ Type: "required" }]}
                  />
                </div>

                {ShowPublish && (
                  <div className="event-publish-schedule">
                    <Input
                      element="datetime-local"
                      CustomFormGroupCls="event-create-field"
                      InputClassName="event-create-input event-create-input--datetime"
                      Register={register}
                      Errors={errors}
                      FieldName="publishTime"
                      Label=""
                      ValidationArr={[
                        { Type: "required" },
                        { Type: "minLength", value: 3 },
                        { Type: "maxLength", value: 50 },
                      ]}
                    />
                  </div>
                )}

                <p className="event-settings-note">
                  Time zone is the same as your event&apos;s
                </p>

                <SubmitButtonGroup
                  formId="publishForm"
                  SubmitBtnText="Post"
                  GroupClassName="event-publish-footer event-create-actions"
                  HideCancelBtn={true}
                  isLoading={loading}
                />
              </form>
            </section>
          </div>
        </MainComponentWrapper>
      )}
    </>
  );
};

export default Publish;
